export const UPDATE_UW_JUDGMENT = "UPDATE_UW_JUDGMENT";
export const UPDATE_EXPOSURE_FLAG = "UPDATE_EXPOSURE_FLAG";
export const UPDATE_STATE_ID = "UPDATE_STATE_ID";
export const DELETE_UW_JUDGMENT = "DELETE_UW_JUDGMENT";
export const DELETE_EXPOSURE = "DELETE_EXPOSURE";
